export const authFeatureKey = "auth";
export const tabFeatureKey ="tabs"
